export default {
  gamePlay: {
    playTitle: 'Now find them, scout!',
    playInstructions:
      '<p>Click on the positions of each of the largest armies you found.</p>',
    playButton: "Let's go!",
    instructions: {
      find: 'Find the army with the most orcs!',
      findInOrder: 'Find the army with the most orcs in correct order!',
      correct: 'Correct!',
      correctBonus: 'Correct, order bonus!',
      incorrect: 'Not the one, scout!',
    },
  },
  rounds: {
    end: 'End of Round {{it.round}}',
    playNext: 'Play next round!',
    all: 'Excellent! You got {{it.correct}} trials correct!',
    some: 'Great job! You got {{it.correct}} trials correct in this round.',
    none: "Good try. Let's keep practicing!",
  },
  levelUp: {
    title: 'Amazing job, level up!!!',
    bodyRender: (level: number) =>
      `Moving to level ${level}, and you got some tickets!`,
  },
  gameComplete: {
    playTitle: 'Game Completed!',
    playInstructions:
      'Great work, you completed the game for the day. Keep practicing!',
    playButton: 'Return to games',
  },
  instructions: [
    {
      title: "We're Under Attack!",
      body:
        "You're not a moment too soon!<br>\n" +
        'The ORC ARMY is attacking and only you can stop them!',
      buttonText: 'Got it.',
      buttonAction: 'goToNext',
      audio:
        '/assets/games/ScoutTrainer/audio/instructions-we-re-under-attack-you.mp3',
    },
    {
      title: 'Identify Targets!',
      body:
        'FIRST, find the LARGEST orc army in each wave.<br>\n' +
        'Click them to mark their spot!',
      buttonText: 'Got it.',
      buttonAction: 'goToNext',
      audio:
        '/assets/games/ScoutTrainer/audio/instructions-identify-targets-first.mp3',
    },
    {
      title: 'Locate and Banish!',
      body:
        'REMEMBER where you saw the army with the most orcs in each wave.<br>' +
        'To win, click their spots, IN the ORDER you scouted them!',
      buttonText: 'Got it.',
      buttonAction: 'goToNext',
      audio:
        '/assets/games/ScoutTrainer/audio/instructions-locate-and-banish-remem.mp3',
    },
    {
      title: 'Ready to start?',
      body: 'Press yes to start, no to see the instructions again.',
      buttonText: 'yes',
      buttonText2: 'no',
      buttonAction: 'goToPlay',
      buttonAction2: 'goToBeginning',
      audio:
        '/assets/games/ScoutTrainer/audio/instructions-ready-to-start-press-ye.mp3',
    },
  ],
};
